module.exports = __webpack_public_path__ + "media/images/bg_faq_mv_pc-2867dab89a69341324214bcc3243f48d.jpg";